import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Navbar } from "../../components/common/Navbar";
import {
  PostComposer,
  FeedList,
  FriendRecommendations,
  CurrentFriends,
} from "../../components/collaboration";

export const CollaborationPage: React.FC = () => {
  const navigate = useNavigate();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [currentFriendsRefreshTrigger, setCurrentFriendsRefreshTrigger] =
    useState(0);

  const handleBackToDashboard = () => {
    navigate("/dashboard");
  };

  const handlePostCreated = () => {
    // Trigger feed refresh when a new post is created
    setRefreshTrigger(prev => prev + 1);
  };

  const triggerCurrentFriendsRefresh = () => {
    setCurrentFriendsRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="bg-[#eeeff6] w-full min-h-screen flex flex-col">
      {/* Navbar */}
      <Navbar />

      {/* Main Content with top padding to account for fixed navbar */}
      <main className="pt-[70px] px-4 sm:px-6 pb-6 flex-1">
        <div className="w-full max-w-[1392px] mx-auto mt-4 sm:mt-8">
          {/* Header with back button */}
          <div className="flex items-center gap-4 mb-6 sm:mb-8">
            <Button
              onClick={handleBackToDashboard}
              variant="ghost"
              className="flex items-center gap-2 text-[#373e46] hover:bg-gray-100 p-2 rounded-lg w-auto"
            >
              <ArrowLeftIcon className="w-5 h-5" />
            </Button>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#373e46]">
              Collaboration
            </h2>
          </div>

          {/* Two-panel layout */}
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
            {/* Right Panel - Friend Recommendations & Current Friends (35% on desktop) - Order 1 for mobile, 2 for desktop */}
            <div className="lg:w-[35%] lg:max-w-[400px] order-1 lg:order-2">
              <div className="lg:sticky lg:top-[90px] space-y-6">
                {/* Friend Recommendations (with pending requests) */}
                <FriendRecommendations
                  onFriendAccepted={triggerCurrentFriendsRefresh}
                />

                {/* Current Friends */}
                <CurrentFriends refreshTrigger={currentFriendsRefreshTrigger} />
              </div>
            </div>

            {/* Left Panel - Collaboration Feed (65% on desktop) - Order 2 for mobile, 1 for desktop */}
            <div className="flex-1 lg:w-[65%] space-y-6 order-2 lg:order-1">
              {/* Post Composer */}
              <PostComposer onPostCreated={handlePostCreated} />

              {/* Feed List */}
              <FeedList
                refreshTrigger={refreshTrigger}
                onFriendRequestAccepted={triggerCurrentFriendsRefresh}
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
